import React from 'react';
import Layout from '@/components/Layout';
import PageHeader from '@/components/PageHeader';
import CtaBand from '@/components/CtaBand';
import TrustRow from '@/components/TrustRow';
import { ShieldCheck, Heart, Star, Wrench } from 'lucide-react';

export default function AboutPage() {
  return (
    <Layout>
      <PageHeader
        eyebrow="About Royal Palm Services"
        title="South Florida's quietly-trusted service."
        subtitle="For over two decades, Royal Palm Services has cared for the homes and businesses of South Florida's most discerning clients. We treat your property like it's our own."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <img src="https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=1200&q=80" alt="Luxury living room" className="rounded-2xl border border-[#E6E9EE] w-full aspect-[4/3] object-cover" />
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-[#C8922F] font-semibold">Our Story</div>
            <h2 className="font-headline text-3xl md:text-4xl text-[#17352D] mt-1">Built on craftsmanship and word-of-mouth.</h2>
            <p className="mt-4 text-slate-700">From our first job in Palm Beach Gardens to managing recurring maintenance across 40+ commercial properties, our reputation has been earned one careful project at a time. We're family-owned, locally operated, and fully insured for every job.</p>
            <TrustRow className="mt-6" />
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
          {[{ icon: ShieldCheck, t: 'Fully Insured', d: 'General liability + Worker’s Comp on every job.' }, { icon: Wrench, t: 'Skilled Craftspeople', d: 'In-house teams across every trade.' }, { icon: Heart, t: 'Concierge Service', d: 'One point-of-contact for every project.' }, { icon: Star, t: '4.9 / 5 Avg Rating', d: 'Across Google, Facebook, BBB.' }].map(s => (
            <div key={s.t} className="rounded-2xl border border-[#E6E9EE] bg-white p-5">
              <div className="h-10 w-10 rounded-xl bg-[#F2F7F5] border border-[#C7DED4] flex items-center justify-center"><s.icon className="h-5 w-5 text-[#17352D]" /></div>
              <div className="mt-3 font-headline text-lg text-[#17352D]">{s.t}</div>
              <div className="text-sm text-slate-600 mt-1">{s.d}</div>
            </div>
          ))}
        </div>
      </section>
      <CtaBand />
    </Layout>
  );
}
